<template>
  <div class="animated fadeIn">
    <b-card v-if="showFrm==false">
      <div slot="header">Kiriman Titipan Bermasalah, Agen Libur/Tutup.
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click.stop="print()">
            <i class="fa fa-file-excel-o"></i> Export
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>

      <b-row  >
        <b-col md="6" lg="5" xl="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 pr-1">Tanggal Kirim</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.tanggal"
              type="date"
              :state="!$v.model.tanggal.$error"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="proses()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
        <span class="text-muted" v-if="(tblData.items>0)"> Setelah action edit/ubah Agen, silahkan klik <strong>Process</strong> untuk memastikan error telah hilang</span>
      </b-row>

      <b-table
        class="mb-0 my-table-scroll"
        ref="table"
        outlined
        hover
        style="font-size:smaller;"
        :fields="tblFields"
        :items="tblData.items"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
      >
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
          </div>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing
            {{(tblData.page - 1) * tblData.limit + 1}}
            to
            {{tblData.page * tblData.limit}}
            of
            {{tblData.total}}
            entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="showFrm==true">
      <b-col md="10" lg="8" xl="6">
        <b-card>
          <div slot="header"> Ubah - AGEN untuk Kiriman Titipan</div>

            <b-input-group >
              <b-input-group-prepend><label>Nama Customer</label></b-input-group-prepend>
              <b-form-input  v-model="frmdata.CustName" ></b-form-input>
            </b-input-group >

            <b-input-group >
              <b-input-group-prepend><label>Alamat Kirim</label></b-input-group-prepend>
              <b-form-input  v-model="frmdata.DeliveryAddr" ></b-form-input>
            </b-input-group >
            <b-row no-gutters>
              <b-col md="4">
                <b-input-group >
                  <b-input-group-prepend><label>Tgl. Kirim</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.tanggal" type="date" disabled ></b-form-input>
                </b-input-group >
              </b-col>
              <b-col md="4">    
                <b-input-group >
                    <b-input-group-prepend><span class="p-2">Total Kiriman</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.totkirim" disabled ></b-form-input>
                    <b-input-group-prepend>
                        <span class="input-group-text" >Eksemplar</span>
                    </b-input-group-prepend>
                </b-input-group >
              </b-col>
            </b-row>
            <b-input-group >
              <b-input-group-prepend><label>Titip ke AGEN</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.namaAgentDititip" placeholder="Item Name" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranAgenShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-btn text="Button" id="btnKoranAgenCleat" v-on:click="clearTitipanAgen()" class="ml-1">
                  <i class="fa fa-close"></i>
                </b-btn>
            </b-input-group >
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="saveAgen()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Agen Koran"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" customer_group="KORANAGEN"></lku-koran-cust>
    </b-modal>


    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>



<script>
import { validationMixin } from "vuelidate";
import { required, } from "vuelidate/lib/validators";
import moment from "moment";
import toastr from "mini-toastr";
import Loading from "vue-loading-overlay";
import koran_report from "../../apis/koran_report";
import lkuKoranCust from "../lookup/lkuKoranCust";

toastr.init();

export default {
  components: { Loading,lkuKoranCust },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required },
    },
    frmdata: {
        kirimanKey: { required },
    },    
  },
  data() {
    return {
      isLoading: false,
      lkuKoranAgenShow: false,
      showFrm:false,
      model: { tanggal: null },
      frmdata: { kirimanKey: null},    
      tblData: {
        tanggal: null,
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "modified",
        sortDesc: false
      },
      tblFields: [
        { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "tanggal",
            label: "Tanggal Kiriman",
            thStyle: "width:160px",
            sortable: true
          },
          {
            key: "nofaktur",
            label: "No Faktur",
            thStyle: "width:160px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Nama Customer",
            sortable: true
          },
          {
            key: "DeliveryAddr",
            label: "Alamat Kirim",
          },
          {
            key: "totpaid",
            label: "Kiriman Berbayar",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "gratis",
            label: "Kiriman TdkBayar",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "totkirim",
            label: "Total Kiriman",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "namaAgentDititip",
            label: "Kiriman diTitip ke AGEN",
            thClass: "text-center",
            tdClass: "text-center"
          },
        { key: "action", label: "Action", thStyle: "width:40px" },
      ],      
      showReport: false,
      reportUrl: `${location.origin}/#load`,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: function() {
    if (this.$route.params.tanggal) {
      this.model.tanggal=this.$route.params.tanggal;
      this.proses();
    }
  },  
  methods: {
    proses: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.tblData.items = null;
          this.isLoading = true;
          const resp = await koran_report.titipanBermasalah({tanggal: moment(this.model).format('YYYY-MM-DD')});
          console.log(resp);
          this.tblData.items=resp;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;

          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    print: async function() {
      toastr.error(' Export aja bukan Print', "ERROR MESSAGE", 10000);
    },
    rowClicked: function(){
        console.log("getDataPesanan");
    },
    edit: function(data) {
      if (data.kirimanKey) {
        this.terpilih=data;
        // router.push({
        //   name: "koran.kirimanfrm",
        //   params: { kirimanKey: data.kirimanKey }
        // });
        this.frmdata.kirimanKey=data.kirimanKey;
        this.frmdata.CustName=data.CustName;
        this.frmdata.tanggal=moment(data.tanggal).format('YYYY-MM-DD');
        this.frmdata.totkirim=data.totkirim;
        this.frmdata.DeliveryAddr=data.DeliveryAddr;
        this.frmdata.kirimtitipke=data.kirimtitipke;
        this.frmdata.namaAgentDititip=data.namaAgentDititip;
        this.showFrm=true;
      } else {
        toastr.warn("Silahkan pilih data yang ingin diubah!");
      }
    },
    onSelectKoranAgen(_selected) {
      // if (this.model.customer_id === _selected.customer_id) {
      //       toastr.error("Pilih Customer yang berbeda dg Agen untuk dititipkan.");
      // } else {
          this.frmdata.namaAgentDititip = `${_selected.CustName} | ${_selected.CustCode}`;
          this.frmdata.kirimtitipke = _selected.customer_id;
          this.lkuKoranAgenShow = false;
      // }
    },    
    saveAgen: async function() {
      if (this.invalidFrmdata) {
          console.log('validation : ', this.$v.frmdata);
          console.log('frmdata obj : ',this.frmdata);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        try {
          this.showFrm = false;
          await koran_report.titipanUpdateAgen(this.frmdata);
          // this.refresh();          
          this.terpilih._rowVariant="success";
        } catch (error) {
          this.showFrm = true;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }            
        }
      }
    },
    closeFrm() {
        this.showFrm = false;
    },
    close() {
      router.push({ name: "koran.home" });
    },
    clearTitipanAgen() {
      this.frmdata.kirimtitipke='';
      this.frmdata.namaAgentDititip='';
    }
  }
};
</script>